//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  mounted() {
    // Redirect to new franchising site
    let path = this.$route.fullPath.replace('/franchising/','')
    path = path.replace('/franchising','') // replace both url types
    window.location.replace('https://perkinsfranchising.com/'+path);
  },
  props: [
    'content'
  ],
  methods: {
    scrubLink(link) {
      return link.replace('pages', '')
    },
  },
  computed: {
    ...mapState([
      'menus',
    ]),
    franchiseNav() {
      return this.menus.franchising ? this.menus.franchising.content.links : []
    }
  }
}
